import React from "react";
import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";

export default function LandingFooter() {
  const { t } = useLanguage();

  return (
    <footer className="border-t border-[#DCD4C6] py-10" style={{ background: "#F1EBE1" }}>
      <div className="max-w-7xl mx-auto px-5 sm:px-8 flex flex-col md:flex-row items-center justify-between gap-4">

        {/* Logo */}
        <div
          className="flex items-center gap-2 text-[#5C554E]"
          style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontStyle: "italic", fontWeight: 600, fontSize: "1.2rem" }}
        >
          <div className="w-6 h-6 rounded-full border border-[#C17F59] flex items-center justify-center">
            <Compass size={12} color="#C17F59" strokeWidth={1.5} />
          </div>
          Voyage-r
        </div>

        {/* Links */}
        <div className="flex gap-6 text-sm text-[#9A8F86]" style={{ fontFamily: "'Lora', Georgia, serif" }}>
          <Link to="/about" className="hover:text-[#5C554E] transition-colors">À propos</Link>
          <Link to="/terms" className="hover:text-[#5C554E] transition-colors">{t("landing.footer_tos")}</Link>
          <Link to="/privacy" className="hover:text-[#5C554E] transition-colors">{t("landing.footer_privacy")}</Link>
          <span className="cursor-pointer hover:text-[#5C554E] transition-colors">Contact</span>
        </div>

        {/* Tagline */}
        <p className="text-xs text-[#9A8F86] italic" style={{ fontFamily: "'Lora', Georgia, serif" }}>
          Voyage conçu sur mesure · Relu et validé par moi, Diego
        </p>

      </div>
    </footer>
  );
}
